export const getPdfDownloadUrl = (code: any, name: any) => {
    return `${process.env.REACT_APP_PDF_DOWNLOAD_URL}?code=${code}&name=${encodeURIComponent(name)}`;
};

export async function downloadPDF(endpointURL: any) {
    try {
        const response = await fetch(endpointURL);

        if (!response.ok) {
            console.error('Erro ao buscar PDF:', response.status);
            return;
        }

        const { data, nome_product_guide } = await response.json();

        if (!data) {
            console.error('PDF não encontrado na resposta');
            return;
        }

        const binaryString = atob(data);
        const binaryArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            binaryArray[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([binaryArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const link: any = document.createElement('a');
        link.href = url;
        link.download = nome_product_guide ?? 'documento.pdf';
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (error) {
        console.error('Erro ao fazer o download do PDF:', error);
    }
}


